export const COPY_CUT_FILE_DATA = 'COPY_CUT_FILE_DATA';
